import React from "react";
import { cn } from "../../utils/cn";

export const Skeleton = ({
  className,
  shape = "rectangle",
  size,
  width,
  height,
  borderRadius,
  style,
  ...props
}) => {
  const dynamicStyle = {
    ...style,
    ...(width ? { width } : {}),
    ...(height ? { height } : {}),
    ...(size ? { width: size, height: size } : {}),
    ...(borderRadius ? { borderRadius } : {}),
  };

  return (
    <div
      style={dynamicStyle}
      className={cn(
        "animate-pulse bg-urb-border/50",
        shape === "circle" ? "rounded-full" : "rounded-lg",
        className
      )}
      {...props}
    />
  );
};

export default Skeleton;
